// extracted by mini-css-extract-plugin
export default {"container":"SectionTitle_container__ClC8F"};